// extracted by mini-css-extract-plugin
module.exports = {"container":"SeoLinks_container__j9Ehd","linkSection":"SeoLinks_linkSection__d7hBH","containerCurated":"SeoLinks_containerCurated___QhXY"};